module.exports = __webpack_public_path__ + "media/images/lp/lp08-589f165f02dea13f71967ff39511d1bd.webp";